import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { LOCATION_URL } from '../config';

const LocationContext = createContext();

export const useLocation = () => useContext(LocationContext);

export const LocationProvider = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = useState(() => {
    return localStorage.getItem('selectedLocation') || 'efin';
  });

  const lastSavedLocation = useRef(null);  // Track last saved location to backend

  // Save location to localStorage on change
  useEffect(() => {
    localStorage.setItem('selectedLocation', selectedLocation);
  }, [selectedLocation]);

  // Save location to backend only if it changed
  useEffect(() => {
    const saveLocationToBackend = async () => {
      if (selectedLocation.toUpperCase() === lastSavedLocation.current) {
        // Location hasn't changed, no need to save
        return;
      }

      try {
        const response = await fetch(LOCATION_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ selectedLocation: selectedLocation.toUpperCase() }),
        });

        if (response.ok) {
          lastSavedLocation.current = selectedLocation.toUpperCase();
        } else {
          console.error('Failed to save location to backend');
        }
      } catch (error) {
        console.error('Error saving location to backend:', error);
      }
    };

    saveLocationToBackend();
  }, [selectedLocation]);

  return (
    <LocationContext.Provider value={{ selectedLocation, setSelectedLocation }}>
      {children}
    </LocationContext.Provider>
  );
};
